import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

import { FaCircleCheck } from 'react-icons/fa6';
import { Skeleton, Tooltip, Avatar } from '@mui/material';

// ✅ Clear
const DemographicChartModal = ({ countryName, onClose }) => {
    const [defaultData, setDefaultData] = useState([]);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hoveredData, setHoveredData] = useState(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const history = useNavigate();

    const handleHoverCardLeave = (e) => {
        const target = e.relatedTarget;
        if (!(target instanceof Element) || !target.closest(".user-item")) {
            setHoveredData(null);
        }
    };


    const handleMouseEnterItem = (value, e) => {
        const rect = e.target.getBoundingClientRect();
        setPosition({ x: rect.right - 230, y: rect.top });
        setHoveredData(value);
    };

    const handleMouseLeaveItem = (e) => {
        const target = e.relatedTarget;
        if (!(target instanceof Element) || !target.closest(".dashboard-popup-hover-card")) {
        setHoveredData(null);
        }
    };
    
        
    useEffect(() => {
        setIsLoading(true)
        api.getDashboardContactsByCountry(countryName).then((response) => {
            setIsLoading(false)
            if (response?.status) {
                setData(response.data);
                setDefaultData(response.data);
            }
        });
    }, [countryName])
    return (
        <Modal show={'true'} onHide={onClose} centered size="md">
            <Modal.Body>
                <div className="dashboard-hover-contacts-container">
                    <div className="mb-2 ml-0 pl-0">
                        <div className="row" style={{ marginBottom: 20 }}>
                            <div className="col-12 text-centera">
                                <h5 style={{ marginBottom: 0, padding: '5px 10px 0 10px' }}>Contacts from { countryName }</h5>
                                <button className="btn modal-close-icon" style={{ top: '-5px' }} onClick={onClose}>
                                    <svg
                                        id="Component_127_1"
                                        height="16"
                                        width="16"
                                        data-name="Component 127 – 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 19.295 19.289"
                                    >
                                        <path
                                            id="Icon_ionic-ios-close"
                                            data-name="Icon ionic-ios-close"
                                            d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
                                            transform="translate(-11.285 -11.289)"
                                        />
                                    </svg>
                                </button>
                                <hr />
                            </div>
                        </div>
                        <div
                            style={{
                                maxHeight: '70vh',
                                overflowY: 'auto',
                                padding: '0 10px',
                                scrollbarWidth: 'thin',
                                scrollbarColor: 'transparent transparent',
                                marginTop: '-20px'
                            }}
                        >

                            <div className="row form-group">
                                <div className="col-12">

                                    <div className="form-inline navbar-search">
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <input
                                                type="text"
                                                className="form-control bg-white border"
                                                placeholder="Search"
                                                aria-label="Search"
                                                aria-describedby="basic-addon2"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value) {
                                                        setData(defaultData?.filter(item => item.name.toLowerCase().includes(value.toLowerCase())) || []);
                                                    } else {
                                                        setData(defaultData || []);
                                                    }
                                                }}
                                                style={{ width: '100%', paddingRight: 36, borderRadius: '32px', height: '35px' }}
                                            />
                                            <span
                                                className="searchIcon"
                                                style={{
                                                    position: 'absolute',
                                                    right: 10,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    color: '#888',
                                                    pointerEvents: 'none'
                                                }}
                                            >
                                                <FaSearch />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                isLoading ? (
                                    [...Array(25)].map((e, i) => (
                                        <div className="row form-group">
                                            <div className="col-12">
                                                <div className="w-full flex justify-content-between align-items-center">
                                                    <div className="flex align-items-center">
                                                        <div className="avatar" style={{ width: '40px', padding: '0 1px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={'36px'} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                        <div className="ml-2">
                                                            <h6 className="" style={{ width: '250px' }}>
                                                                <Skeleton variant="rounded" width={'100%'} height={'10px'} style={{ borderRadius: '32px' }} />
                                                            </h6>
                                                            <p className="m-0" style={{ width: '150px' }}>
                                                                <Skeleton variant="rounded" width={'100%'} height={'10px'} style={{ borderRadius: '32px' }} />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="actions">
                                                        <div style={{ width: '75px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={'27px'} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <>
                                        {
                                            data?.length > 0 && (
                                                data?.map((item, index) => (
                                                    <div
                                                        className="row"
                                                        key={index}
                                                        onMouseEnter={(e) => handleMouseEnterItem(item, e)}
                                                        onMouseLeave={handleMouseLeaveItem}
                                                    >
                                                        <div className="col-12 user-item">
                                                            <div className="w-full flex justify-content-between align-items-center">
                                                                <div className="flex align-items-center">
                                                                    <div className="avatar">
                                                                        {
                                                                            item?.logo ? (
                                                                                <img
                                                                                    src={item?.logo}
                                                                                    style={{
                                                                                        height: '40px',
                                                                                        width: '40px',
                                                                                        borderRadius: '32px',
                                                                                        objectFit: 'cover',
                                                                                        display: 'block'
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <Avatar />
                                                                            )
                                                                        }
                                                                    </div>
                                                                    <div className="ml-2">
                                                                        <div className="m-0 flex align-items-center gap-2">
                                                                            <span>
                                                                                {item?.name}
                                                                            </span>
                                                                            <span>

                                                                                {item?.verification_level?.percentage == '100' && (
                                                                                    <Tooltip title={`Verification percentage: ${item?.verification_level?.percentage}%`} arrow placement="top">
                                                                                        <div className="text-success" style={{ fontSize: '17px' }}>
                                                                                            <FaCircleCheck />
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <p className="m-0 text-gray-600">{ item?.contact_name ?? item?.contact_number }</p>
                                                                    </div>
                                                                </div>
                                                                <div className="actions">
                                                                    <button
                                                                        className="btn-gradient btn-block btn-gradient-small"
                                                                        onClick={() => { 
                                                                            history(`/contacts/${item?.id}`);
                                                                        }}
                                                                    >
                                                                        View 
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )
                                        }

                                        {hoveredData && (
                                            <div
                                                className="dashboard-popup-hover-card"
                                                style={{ top: position.y, left: position.x, zIndex: '9999' }}
                                                onMouseLeave={handleHoverCardLeave}
                                            >
                                                <div className="w-full flex gap-3">
                                                    <div>
                                                        <div className="avatar">
                                                            {
                                                                hoveredData?.logo ? (
                                                                    <img
                                                                        src={hoveredData?.logo}
                                                                        style={{
                                                                            height: '40px',
                                                                            width: '40px',
                                                                            borderRadius: '32px',
                                                                            objectFit: 'cover',
                                                                            display: 'block'
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Avatar />
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="dashboard-popup-hover-card-name flex align-items-center gap-2">
                                                            <span>
                                                                {hoveredData?.name}
                                                            </span>
                                                            <span>

                                                                {hoveredData?.verification_level?.percentage == '100' && (
                                                                    <Tooltip title={`Verification percentage: ${hoveredData?.verification_level?.percentage}%`} arrow placement="top">
                                                                        <div className="text-success" style={{ fontSize: '17px' }}>
                                                                            <FaCircleCheck />
                                                                        </div>
                                                                    </Tooltip>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div className="dashboard-popup-hover-card-username">
                                                            {hoveredData?.contact_name}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="dashboard-popup-hover-card-stats">
                                                    <div>
                                                    <strong>{hoveredData?.no_of_quotations}</strong>
                                                    <span>Quotations</span>
                                                    </div>
                                                    <div>
                                                    <strong>{hoveredData?.no_of_sales_orders}</strong>
                                                    <span>Sales Orders</span>
                                                    </div>
                                                    <div>
                                                    <strong>{hoveredData?.no_of_invoices}</strong>
                                                    <span>Invoices</span>
                                                    </div>
                                                </div>
                                                <button
                                                    className="btn-gradient btn-block btn-gradient-medium"
                                                    onClick={() => { 
		                                                history(`/contacts/${hoveredData?.id}`);
                                                    }}
                                                >
                                                    View Profile
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DemographicChartModal;
